import { h } from 'preact';
import { joinClasses } from 'utils/utils';
// import formatDateTime from 'utils/formatDateTime';
import { getButtons } from 'components/editor/pages/landing/misc';

import SelectableSection from 'components/editor/selectableSection';
import ScrollList from 'components/editor/pages/landing/scrollList/scrollList';
import ArrowRight from 'components/icons/arrowRight';

import s from 'components/editor/pages/landing/scrollList/moviesList.sss';

export default class MoviesList extends ScrollList {

	s = s;

	constructor(props) {
		super(props);
		// this.onShowtimesAnimationEnd = this.onShowtimesAnimationEnd.bind(this);
	}

	// onShowtimesAnimationEnd(e) {
	// 	if (e.animationName === s.showtimesTimer) {
	// 		const id = e.target.closest('[data-id]')?.dataset.id;
	// 		if (id) {
	// 			const max = e.target.parentElement.children.length || 1;
	// 			this.setState({ [`activeShowtime-${id}`]: ((this.state[`activeShowtime-${id}`] || 0) + 1) % max });
	// 		}
	// 	}
	// }
	// onShowtimesTransitionEnd(e) {
	// 	if (e.propertyName === 'transform') {
	// 		e.target.style.transition = 'none';
	// 		e.target.style.transform = 'translateX(0)';
	// 		e.target.clientWidth;
	// 		e.target.style.transition = '';
	// 		e.target.style.transform = '';
	// 	}
	// }

	renderTitleLink() {
		const titleLink = this.props.titleLink;
		if (!titleLink) return null;
		return (
			<div class={s.titleLink}>
				{titleLink.label}
				<svg width="13" viewBox="0 0 13 25" xmlns="http://www.w3.org/2000/svg">
					<path fill-rule="evenodd" clip-rule="evenodd" d="M0.704262 1.78002C0.431262 1.48752 0.431262 1.01202 0.704262 0.719522C0.978762 0.427023 1.42126 0.427023 1.69576 0.719522L12.2948 11.968C12.5678 12.262 12.5678 12.7375 12.2948 13.03L1.69576 24.28C1.55926 24.427 1.37926 24.499 1.20076 24.499C1.02076 24.499 0.842262 24.427 0.704262 24.28C0.431262 23.9875 0.431262 23.512 0.704262 23.218L10.8203 12.499L0.704262 1.78002Z" fill="white"/>
				</svg>
			</div>
		);
	}

	renderTitle() {
		return (
			<div class={s.titleWrapper}>
				<h2 class={s.title}>{this.props.title}</h2>
				{this.renderTitleLink()}
			</div>
		);
	}

	// getNextShowtimeLabel(showtime) {
	// 	if (!showtime) return '';
	// 	return `Next showing ${formatDateTime(showtime.dateTime, 'ddd h:mmtt')} at ${showtime.name}`;
	// }

	// getNextShowtimes(item, i) {
	// 	const id = item?.movie?.id;
	// 	const data = this.props.nextShowtimes?.[id];
	// 	if (!data) return null;

	// 	return data.map((showtime, j) => {
	// 		if (j > 0) return;
	// 		const label = this.getNextShowtimeLabel(showtime);
	// 		return (
	// 			<div class={joinClasses(j === (this.state[`activeShowtime-${id}`] || 0) && s.active, i === this.state.currentItem && s.currentItem)} data-content={label}>
	// 				{label}
	// 				<span>{label}</span>
	// 			</div>
	// 		);
	// 	});
	// }

	renderButtons(item) {
		const list = getButtons(item?.movie, item);
		if (!list.length) return;

		return (
			<div class={s.buttons} key="buttons">
				{list.map(e => <div class={joinClasses(s.button, e.type === 'primary' && s.primary)}>{e.label}</div>)}
			</div>
		);
	}

	renderItem(item, i) {
		const path = this.props.automatic ? `/carousels/overrides/${item.movie?.id}` : `${this.props.basePath || ''}/list/${i}`;
		const movieTitle = item.movie?.title;
		return (
			<SelectableSection section={path} activeElement={this.props.activeElement} class={s.item} data-id={item.movie?.id} key={item.movie?.id || i}>
				<div class={s.posterWrapper}>
					<img class={s.poster} src={item.movie?.onesheet?.url} alt={item.movie?.onesheet?.alt || `${movieTitle} poster image`} width="1050" height="1551" />
				</div>
				<div class={s.details}>
					{/* Have to use an extra wrapper to let the image control the width - is there a better way ? */}
					<div>
						<div class={s.name} key="name">
							<span>{movieTitle}</span>
							<ArrowRight class={s.arrow} />
						</div>
						{/* <div class={s.showtimes} onAnimationEnd={this.onShowtimesAnimationEnd} onTransitionEnd={this.onShowtimesTransitionEnd}>{this.getNextShowtimes(item, i)}</div> */}
						{this.renderButtons(item, i)}
					</div>
				</div>
			</SelectableSection>
		);
	}

}